<template>
    <div>
        <div class="filter-heading cf">
            <p class="filter-title">
                {{ label }}
            </p>
        </div>
        <div class="filter-body">
            <vue-slider ref="slider" v-model="values" v-bind="options" @drag-end="bump"></vue-slider>
        </div>
    </div>
</template>

<script>
    import vueSlider from 'vue-slider-component'
    import { TextFilter } from '../../../Services/Search/TextFilter.js';
    import UrlHelpers from '../../../Services/UrlHelpers.js';

    export default {
        components: {
            vueSlider,
        },
        props: {
            handle: {
                type: String,
            },
            max: {
                type: String|Number,
                default: undefined
            },
            items: {
                type: [Object,Array],
                default() {
                    return [];
                }
            }
        },
        data() {
            return {
                values: [],
                original: [],
                object: {},
                changed: false,
                options: {
                    min: 0,
                    max: 10000,
                    interval: 1,
                    tooltip: 'always',
                    tooltipDir: 'bottom',
                    formatter: (v) => `£${('' + v).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`,
                }
            }
        },
        mounted() {

            if (this.items.max_price) {
                this.object.max = this.items.max_price.value;
                this.object.min = 0;
            } else {
                this.object = this.items;
            }

            let min = this.object.min,
                max = this.object.max;

            this.original = [min,max];

            this.options.min = this.object.min;
            this.options.max = Math.ceil(this.object.max);

            let range = UrlHelpers.getParam(this.handle);

            if (range) {
                range = range.split(':');
                this.$refs.slider.setValue(range);
                this.loaded();
            } else {
                this.values = [
                    this.object.min,
                    this.object.max
                ];
            }
        },
        computed: {
            label() {
                return this.handle.replace('_', ' ').titleCase();
            },
        },
        methods: {
            bump(value) {
                this.$emit('bump', new TextFilter(this.handle, this.values));
            },
            loaded() {
                this.$emit('loaded', new TextFilter(this.handle, this.values));
            }
        },
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/Components/Search/Filters/RangeFilter.vue